import { getSilentAuth } from './silentAuth';
export function login(client, continueTo) {
    var silentAuth = getSilentAuth(client);
    silentAuth.login({
        redirectUri: continueTo
    });
}
export function logout(client, continueTo) {
    if (continueTo === void 0) { continueTo = 'https://artists.spotify.com/home'; }
    var silentAuth = getSilentAuth(client);
    silentAuth.logout(continueTo);
}
